export const messages = {
  title: {
    id: 'admin/promotions.form.budget.modal.unauthoraized.title',
  },
  description: {
    id: 'admin/promotions.form.budget.modal.unauthoraized.description',
  },
  subtitle: {
    id: 'admin/promotions.form.budget.modal.unauthoraized.subtitle',
  },
  cancel: {
    id: 'admin/promotions.utils.close',
  },
  continue: {
    id: 'admin/promotions.utils.continue',
  },
}
